var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 65,
    viewBox: "0 0 181 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M116.071 22.7237C113.382 20.0317 110.132 18.6847 106.322 18.6847C102.509 18.6847 99.2602 20.0317 96.5708 22.7237C93.8813 25.4147 92.5384 28.651 92.5384 32.4292C92.5384 36.2605 93.8813 39.535 96.5708 42.2528C99.2602 44.9711 102.509 46.329 106.322 46.329C110.132 46.329 113.382 44.9711 116.071 42.2528C118.76 39.535 120.104 36.2605 120.104 32.4292C120.104 28.651 118.76 25.4147 116.071 22.7237ZM121.198 46.9538C117.085 51.015 112.112 53.045 106.282 53.045C100.504 53.045 95.5573 51.015 91.4445 46.9538C87.3313 42.8931 85.2754 38.0004 85.2754 32.2725C85.2754 26.6498 87.3313 21.8607 91.4445 17.9037C95.5573 13.9481 100.504 11.9686 106.282 11.9686C112.112 11.9686 117.085 13.9481 121.198 17.9037C125.31 21.8607 127.367 26.6498 127.367 32.2725C127.367 38.0004 125.31 42.8931 121.198 46.9538ZM63.3316 18.6847C59.6344 18.6847 56.5764 19.9925 54.156 22.6062C51.7352 25.2213 50.5248 28.4948 50.5248 32.4292C50.5248 36.209 51.7604 39.4701 54.2339 42.2136C56.7057 44.9577 59.6612 46.329 63.0971 46.329C65.4406 46.329 67.6269 45.6861 69.6569 44.3979C71.6875 43.1101 73.2227 41.3594 74.2646 39.1448H82.3859C80.9281 43.4143 78.4815 46.7976 75.0456 49.2973C71.6092 51.796 67.6521 53.045 63.1754 53.045C57.5527 53.045 52.8286 51.067 49.0019 47.11C45.1753 43.1539 43.2622 38.2602 43.2622 32.4292C43.2622 26.7024 45.1877 21.8607 49.0406 17.9037C52.8925 13.9481 57.6563 11.9686 63.3316 11.9686C67.8083 11.9686 71.8556 13.3099 75.4745 15.9906C79.0934 18.6723 81.3967 22.0169 82.3859 26.025H74.2646C71.5571 21.1328 67.9125 18.6847 63.3316 18.6847ZM28.6207 21.8087C26.1467 19.5177 23.2707 18.3728 19.991 18.3728C16.0871 18.3728 12.8847 19.7781 10.386 22.5891C8.82401 24.3599 7.80845 26.8586 7.34037 30.0862H32.5638C32.4081 26.8586 31.0931 24.0996 28.6207 21.8087ZM39.5928 35.7084H7.34037C8.12137 38.9128 9.66996 41.4852 11.9867 43.4225C14.3029 45.3598 17.0495 46.329 20.2256 46.329C25.0147 46.329 28.6846 44.1427 31.2364 39.7691H38.5773C37.1194 43.8303 34.698 47.0589 31.3142 49.453C27.9294 51.848 24.1306 53.045 19.9132 53.045C14.4467 53.045 9.76121 51.0284 5.85621 46.9929C1.95224 42.9596 0 38.104 0 32.4292C0 26.7024 1.95224 21.8087 5.85621 17.7475C9.76121 13.6868 14.4977 11.6567 20.0694 11.6567C25.4833 11.6567 30.1301 13.6476 34.0088 17.6304C37.887 21.6133 39.8269 26.3905 39.8269 31.9601C39.8269 32.7937 39.7485 34.0433 39.5928 35.7084Z",
    fill: "url(#paint0_linear_199_1337)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.407 33.9995V38.4082H174.323V33.9995L170.712 26.3066H174.069L175.865 31.1684L177.679 26.3066H181L177.407 33.9995ZM165.305 30.0616L164.036 34.1985H166.557L165.305 30.0616ZM167.973 38.4082L167.392 36.6482H163.183L162.548 38.4082H159.227L164.073 26.3066H166.522L171.329 38.4082H167.973ZM156.306 38.4082H153.586L151.753 30.5884L149.921 38.4082H147.144L144.023 26.3066H147.162L148.777 34.1805L150.573 26.3066H152.95L154.728 34.2171L156.38 26.3066H159.518L156.306 38.4082Z",
    fill: "url(#paint1_linear_199_1337)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.477 41.958L111.082 30.9441H107.411L108.459 23.3388L102.166 33.8284H105.575L103.477 41.958Z",
    fill: "url(#paint2_linear_199_1337)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.739 0.000150681H107.672V8.12976H103.739V0.000150681Z",
    fill: "url(#paint3_linear_199_1337)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.75 30.4206H138.879V34.3545H130.75V30.4206Z",
    fill: "url(#paint4_linear_199_1337)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5475 5.98605L90.954 4.01938L95.0188 11.0592L91.6123 13.0259L87.5475 5.98605Z",
    fill: "url(#paint5_linear_199_1337)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.192 5.35876L120.845 3.41374L116.852 10.3768L120.199 12.3218L124.192 5.35876Z",
    fill: "url(#paint6_linear_199_1337)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.183 17.7573L133.257 14.3987L126.317 18.4326L128.243 21.7911L135.183 17.7573Z",
    fill: "url(#paint7_linear_199_1337)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.698 56.6443H107.631V64.7739H103.698V56.6443Z",
    fill: "url(#paint8_linear_199_1337)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4812 58.7871L90.8924 60.7538L94.9618 53.714L91.5512 51.7473L87.4812 58.7871Z",
    fill: "url(#paint9_linear_199_1337)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.174 59.4153L120.822 61.3604L116.824 54.3979L120.175 52.4523L124.174 59.4153Z",
    fill: "url(#paint10_linear_199_1337)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.177 47.016L133.249 50.3751L126.3 46.3407L128.229 42.9822L135.177 47.016Z",
    fill: "url(#paint11_linear_199_1337)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_199_1337",
    x1: 110.615,
    y1: 34.3697,
    x2: 40.1857,
    y2: 78.9128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_199_1337",
    x1: 176.137,
    y1: 32.9477,
    x2: 155.607,
    y2: 45.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_199_1337",
    x1: 109.909,
    y1: 33.5566,
    x2: 103.073,
    y2: 34.2294,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_199_1337",
    x1: 107.155,
    y1: 4.46151,
    x2: 104.14,
    y2: 4.76132,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_199_1337",
    x1: 137.81,
    y1: 32.5795,
    x2: 132.478,
    y2: 34.8439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_199_1337",
    x1: 94.0361,
    y1: 8.96195,
    x2: 88.4156,
    y2: 9.92017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_199_1337",
    x1: 123.227,
    y1: 8.30228,
    x2: 117.703,
    y2: 9.23765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_199_1337",
    x1: 134.017,
    y1: 18.4555,
    x2: 127.546,
    y2: 20.0505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_199_1337",
    x1: 107.114,
    y1: 61.1057,
    x2: 104.099,
    y2: 61.4055,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_199_1337",
    x1: 93.9779,
    y1: 56.6899,
    x2: 88.3508,
    y2: 57.6504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_199_1337",
    x1: 123.207,
    y1: 57.3409,
    x2: 117.676,
    y2: 58.2787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_199_1337",
    x1: 134.01,
    y1: 47.0393,
    x2: 127.532,
    y2: 48.6378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0877362,
    stopColor: "#43BACE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99973,
    stopColor: "#71B54D"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColor);
export default __webpack_public_path__ + "static/media/color.0b02c7172c47c76e923ab16604266024.svg";
export { ForwardRef as ReactComponent };